import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.hasRedirect(_ctx.item))
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          title: `GO TO ${_ctx.truncate(_ctx.item.Section)}`,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPge(_ctx.item))),
          class: ""
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("mdi-arrow-right ")
          ])),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}